import React from 'react';
import { useFieldArrayMethods } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import { defaultIntervalAvailability } from '../../../../shared/configs/selectionData/intervalAvailabilities';
import { defaultIntervalMode } from '../../../../shared/configs/selectionData/intervalModes';
import Btn, { btnTypes } from '../../../../../../components/btn';
import { useCanAddInterval } from '../../providers/selectedIdsProvider';

const names = fieldNames.scheduleSettingInterval;

const addedData = {
  [names.active]: true,
  [names.mode]: defaultIntervalMode,
  [names.availability]: defaultIntervalAvailability,
};

const AddInterval = () => {
  const canAdd = useCanAddInterval();

  return canAdd ? <Add /> : null;
};

export default AddInterval;

function Add() {
  const { append } = useFieldArrayMethods();

  return (
    <Btn
      type={btnTypes.secondary}
      onClick={() => append(addedData)}
      style={{ fontWeight: 600 }}
    >
      Добавить интервал
    </Btn>
  );
}
